var render = function render(){var _vm=this,_c=_vm._self._c;return _c('NcBreadcrumbs',{staticClass:"crumbs"},[_c('NcBreadcrumb',{attrs:{"title":"Home","href":"#/"},scopedSlots:_vm._u([{key:"icon",fn:function(){return [_c('HomeIcon',{attrs:{"size":20}})]},proxy:true}])}),_vm._v(" "),_vm._l((_vm.parts),function(p){return _c('NcBreadcrumb',{key:p.path,attrs:{"title":p.name,"href":'#' + p.path}})})],2)
}
var staticRenderFns = []

export { render, staticRenderFns }